import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../../../common/components/form/form.module'


export default function MeasureDimensionBasicInfoComponent ({handleInnerFormChange, selectMeasureDimensions}: any) {
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
         
          <InputContainer

                  label="Name"
                  name="Name"
                  onValueChange={(event: any) => {
                    handleInnerFormChange(
                      event.target.value,
                       'Name',

                         )
                       }}
                   type="text"
                   value={selectMeasureDimensions?.Name}
                />
                   <InputContainer

                    label="SystemKeyword"
                    name="SystemKeyword"
                    onValueChange={(event: any) => {
                     handleInnerFormChange(
                     event.target.value,
                    'SystemKeyword',

                             )
                             }}
                     type="text"
                    value={selectMeasureDimensions?.SystemKeyword}
                        />
                        <InputContainer

                            label="Ratio"
                            name="Ratio"
                            onValueChange={(event: any) => {
                            handleInnerFormChange(
                            event.target.value,
                            'Ratio',

                             )
                                }}
                            type="number"
                        value={selectMeasureDimensions?.Ratio}
                        />
                            <InputContainer

                                label="PrimaryDimension"
                                name="IsPrimaryDimension"
                                onValueChange={(event: any) => {
                             handleInnerFormChange(
                                 event,
                                     'IsPrimaryDimension',

                              )
                     }}
                type="checkbox"
                 value={selectMeasureDimensions?.IsPrimaryDimension}
                />
            <InputContainer
              label="DisplayOrder"
              name="DisplayOrder"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'DisplayOrder',

                )
              }}
              type="number"
              value={selectMeasureDimensions?.DisplayOrder}
          />
     </div>
  }
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}